import React, { useContext } from "react";
import { StateContext } from "../store/context";

const ErrorBoundary: React.FC = (): React.ReactElement | null => {
  const { error = null } = useContext(StateContext);
  console.log("error", error);

  if (error) {
    const { message = "Something went wrong" } = error || {};
    return (
      <div className="flex p-2 my-2 bg-error font-bold text-base text-white rounded-md">
        {message}
      </div>
    );
  }
  return null;
};

export default ErrorBoundary;
